import React, { useCallback } from 'react';
import { useDraft } from '../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../Legacy';
import { CommandDispatcher } from '../../concepts/commands/CommandDispatcher';
import { useSubmitter } from '../../platform/Hook';
import { ResultInfoForSubmitter } from '../../ui/ResultInfo';
import { useResolve } from '../Container';
import { Copy, Spacer } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';
import { Button, Input, Prompt } from './../../ui';
import { templateCreate } from './TemplateCommands';

export const addTemplatePopup = (folder?: string) => ({ ui: AddTemplatePopup, args: { folder } });

export const AddTemplatePopup: LFC<PopupProps> = ({ action, dismiss, args }) => {

    const dispatch = useResolve(CommandDispatcher);
    const [draft, patchDraft] = useDraft({ board: '' });

    const invalid = !draft.board.trim();

    const [onSubmit, working, result] = useSubmitter(async () => {
        action(await dispatch(templateCreate, [args.folder, draft.board]));
    }, [args, draft]);

    const onPromptAction = useCallback((confirm: boolean) => {
        if (!confirm) dismiss();
        else if (!invalid) onSubmit();
    }, [invalid, onSubmit]);

    return <Prompt onAction={working ? null : onPromptAction}>
        <Popup w={32}>
            <Popup.Close onAction={() => onPromptAction(false)} />
            <Popup.Title>Add Template</Popup.Title>
            <Popup.Content>
                <Copy>
                    Which board would you like to add to the Template Library?
                    You can provide the board URL or ID.
                    The board will be cloned and published as a template.
                </Copy>
                <Spacer f={2} />
                <Input
                    label="Board"
                    placeholder="https://ludi.co/BOXXXXXXXX"
                    autoFocus
                    value={draft.board}
                    onChange={x => patchDraft({ board: x })}
                />
                <Spacer f={2} />
                <ResultInfoForSubmitter result={result} />
            </Popup.Content>
            <Popup.Actions>
                <Button disabled={invalid || working} variant="primary" onAction={onSubmit}>
                    {working ? 'Adding...' : 'Add'}
                </Button>
            </Popup.Actions>
        </Popup>
    </Prompt>;
};
